import { HttpService, LanguageService } from '@philips-internal/oswald-ui-core/lib/services';

import { Endpoint } from '../constants/endpoints';

interface LocalizationDTO {
  locale: string
  language: string
}

function setup(): Promise<void> {
  return HttpService.get(Endpoint.GET_LOCALE_AND_LANGUAGE, {})
    .then(response => {
      const { locale } = response.body as LocalizationDTO;
      LanguageService.setCurrentLanguage(locale);
    });
}

export {
  setup,
};
